import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ADD_DOSSIER = FORM_FIELDS.EMPLOYEE.DOSSIER.ADD_DOSSIER;

export const dossierValidation = yup.object().shape({
  [ADD_DOSSIER.NAME]: yup.string().required("Name is required"),
  // [ADD_DOSSIER.DATE]: yup.string().required("Date is required"),
});

export type DossierFormData = yup.InferType<typeof dossierValidation>;
